import React from "react";
import { Button, Typography, Box } from "@mui/material";
import { Home as HomeIcon } from "@mui/icons-material";

export default function ErrorPage() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box sx={{ position: "relative", mb: 2 }}>
        <Typography
          variant="h1"
          sx={{
            position: "absolute",
            top: -40,
            left: "50%",
            transform: "translateX(-50%)",
            fontSize: "8rem",
            fontWeight: 800,
            color: "rgba(0, 0, 0, 0.05)",
            userSelect: "none",
            zIndex: 0,
          }}
        >
          404
        </Typography>
        <Box
          sx={{
            position: "relative",
            zIndex: 1,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img
            src="/panda.png"
            alt="Confused Panda"
            style={{ width: "350px", height: "auto", marginBottom: "1rem" }}
          />
        </Box>
      </Box>

      <Box sx={{ mb: 3, width: "100%", maxWidth: 600 }}>
        <Typography
          variant="h4"
          component="h1"
          gutterBottom
          fontWeight="bold"
          sx={{ color: "text.primary", textAlign: "center" }}
        >
          Oops! No Sanduuq here!
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Our confused panda checked everywhere, but the box is empty! Maybe try
          looking somewhere else?
        </Typography>
      </Box>

      <Button
        // component={Link}
        href="/"
        variant="contained"
        color="primary"
        size="large"
        startIcon={<HomeIcon />}
        sx={{ px: 4, py: 1.5, borderRadius: 2, fontWeight: 500 }}
      >
        Take Me Home
      </Button>

      <Typography variant="body2" color="text.disabled" sx={{ mt: 4 }}>
        Lost? Don&apos;t worry, even pandas get confused sometimes.
      </Typography>
    </Box>
  );
}
